// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q1ap","title":"styles_title__1MOSq"};